import script from "./PrivacyView.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyView.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyView.vue?vue&type=style&index=0&id=90eda766&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90eda766"]])

export default __exports__